/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const ApiAccountsSetDefaultVersionUpdateBody = zod.strictObject({
    default_version: zod.number(),
});

export type ApiAccountsSetDefaultVersionUpdateBody = zod.input<
    typeof ApiAccountsSetDefaultVersionUpdateBody
>;
export type ApiAccountsSetDefaultVersionUpdateBodyOutput = zod.output<
    typeof ApiAccountsSetDefaultVersionUpdateBody
>;
